import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirYoutubeQuests() {
  return {
    channels: [],
    minWatchSeconds: 180,
    pointsPerChannel: 10,
    loading: false,
    saving: false,
    resolving: '',
    modal: false,
    editing: false,
    form: {
      id: null,
      handle: '',
      name: '',
      url: '',
      channel_id: '',
      featured_video_id: '',
      sort_order: 0,
      is_active: true,
    },

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.channels = cfg.channels || [];
        this.minWatchSeconds = cfg.minWatchSeconds || 180;
        this.pointsPerChannel = cfg.pointsPerChannel || 10;
      } catch (e) {
        console.error('kasirYoutubeQuests config', e);
      }
    },

    openCreate() {
      this.editing = false;
      this.form = {
        id: null,
        handle: '',
        name: '',
        url: '',
        channel_id: '',
        featured_video_id: '',
        sort_order: (this.channels.length || 0) + 1,
        is_active: true,
      };
      this.modal = true;
    },

    openEdit(ch) {
      this.editing = true;
      this.form = {
        id: ch.id,
        handle: ch.handle || '',
        name: ch.name || '',
        url: ch.url || '',
        channel_id: ch.channel_id || '',
        featured_video_id: ch.featured_video_id || '',
        sort_order: ch.sort_order ?? 0,
        is_active: !!ch.is_active,
      };
      this.modal = true;
    },

    closeModal() {
      this.modal = false;
    },

    payload() {
      const handle = String(this.form.handle || '').replace(/^@/, '').trim();
      return {
        handle,
        name: String(this.form.name || '').trim() || handle,
        url: String(this.form.url || '').trim() || null,
        channel_id: String(this.form.channel_id || '').trim() || null,
        featured_video_id: String(this.form.featured_video_id || '').trim() || null,
        sort_order: Number(this.form.sort_order) || 0,
        is_active: !!this.form.is_active,
      };
    },

    async save() {
      const body = this.payload();
      if (!body.handle) {
        window.toast?.('Handle wajib diisi.', 'error');
        return;
      }
      this.saving = true;
      try {
        if (this.editing && this.form.id) {
          const { data } = await axios.put(`/api/v1/kasir/engagement/youtube-channels/${this.form.id}`, body);
          const updated = data.data;
          const idx = this.channels.findIndex((c) => c.id === updated.id);
          if (idx >= 0) this.channels[idx] = updated;
          else this.channels.push(updated);
          window.toast?.(data.message || 'Channel diperbarui.', 'success');
        } else {
          const { data } = await axios.post('/api/v1/kasir/engagement/youtube-channels', body);
          this.channels.push(data.data);
          this.channels.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
          window.toast?.(data.message || 'Channel ditambahkan.', 'success');
        }
        this.modal = false;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async resolve(ch) {
      this.resolving = ch.id;
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/youtube-channels/${ch.id}/resolve`);
        const updated = data.data;
        const idx = this.channels.findIndex((c) => c.id === updated.id);
        if (idx >= 0) this.channels[idx] = updated;
        window.toast?.(data.message || 'Disinkronkan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal sinkron.', 'error');
      } finally {
        this.resolving = '';
      }
    },

    async remove(ch) {
      const ok = window.confirmDialog
        ? await window.confirmDialog({
            title: 'Hapus channel?',
            message: `Hapus @${ch.handle} dari quest YouTube?`,
            confirmText: 'Hapus',
            variant: 'danger',
          })
        : window.confirm(`Hapus @${ch.handle}?`);
      if (!ok) return;
      try {
        await axios.delete(`/api/v1/kasir/engagement/youtube-channels/${ch.id}`);
        this.channels = this.channels.filter((c) => c.id !== ch.id);
        window.toast?.('Channel dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirYoutubeQuests', createKasirYoutubeQuests);
